/* Bisou Rivage — Journal : la page (thème ALT, 20/10/2026).
   1. Le calendrier du haut : lit les entrées posées par snippets/bisou-journal-calendrier.liquid, dessine le mois en
      cours de lecture (toujours six semaines, pour que le carré ne change pas de taille), écrit la liste du mois, et passe
      d'un mois à l'autre (boutons, flèches du clavier, glissé au téléphone).
   2. Les rangées qui défilent (dernières entrées, « À ne pas manquer ») : flèches sur les côtés et fine ligne de repère.
   3. v4 (21/10, revue téléphone, défaut 12) : un texte provisoire (« … (à écrire) ») ne se montre pas. Sur une carte, il
      disparaît ; dans le calendrier, l'entrée prend le nom écrit sur sa carte (l'artiste, « Résultat du vote »), sinon sa
      rubrique. */
(function () {
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var MOIS_COURT = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  /* 25/10 (Journal en anglais) : le titre provisoire anglais finit par « (to be written) » */
  /* 27/10 (Journal en espagnol et en japonais) : « (por escribir) », 「（執筆予定）」, parenthèses pleine chasse comprises */
  var PROVISOIRE = /[(（](à écrire|to be written|por escribir|執筆予定)[)）]/i;
  /* 25/10 (Journal en anglais) : les textes viennent du snippet, dans la langue de la page ([data-bjk-txt], rendu par | t,
     donc échappé : brut() le remet en texte) ; à défaut, le français d'avant. */
  var TXT0 = { jourAria: '[d] [m] : [t]', aucune: 'Aucune entrée ce mois-ci.', compteZero: 'Aucune entrée', compteUn: '[n] entrée', comptePlus: '[n] entrées', repli: 'Journal', titreMois: '[m] [a]', dateLigne: '[d] [m]' };
  /* 27/10 (Journal en japonais) : le mois du calendrier (« Octobre 2026 », 「2026年10月」) et la date d'une ligne (« 14 oct. », 「10月14日」) suivent la langue */
  function brut(s) { var d = document.createElement('textarea'); d.innerHTML = s; return d.value; }
  function textes(root) {
    var j = {}, t = { mois: MOIS, moisCourt: MOIS_COURT }, k, l;
    try { j = JSON.parse(root.querySelector('[data-bjk-txt]').textContent) || {}; } catch (e) { j = {}; }
    function ok(v) { return typeof v === 'string' && v !== '' && v.indexOf('translation missing') < 0; }
    for (k in TXT0) t[k] = ok(j[k]) ? brut(j[k]) : TXT0[k];
    if (ok(j.mois) && (l = brut(j.mois).split(',')).length === 12) t.mois = l;
    if (ok(j.moisCourt) && (l = brut(j.moisCourt).split(',')).length === 12) t.moisCourt = l;
    return t;
  }
  /* Remplit les jetons [d], [m], [t], [n] d'un texte, en un seul passage (une valeur remise n'est pas relue) */
  function fill(s, v) { return s.replace(/\[(\w)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(v, k) ? v[k] : m; }); }
  function nomDeCarte(a) {
    var n = a && a.querySelector('.bjm__name, .bjm__over, .bjm__coll');
    return n ? n.textContent.trim() : '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function keyOf(d) { return +d.slice(0, 4) * 12 + (+d.slice(5, 7) - 1); }

  function init(root) {
    var T = textes(root);
    var items = [];
    try { items = JSON.parse(root.querySelector('[data-bjk-data]').textContent) || []; } catch (e) { items = []; }
    if (root.getAttribute('data-demo') === '1') {
      /* Les notes en préparation (et leurs dates d'exemple) ne vivent que dans l'aperçu d'un thème non publié */
      var th = window.Shopify && window.Shopify.theme;
      if (!th || !th.role || th.role === 'main') items = [];
    }
    items = items.filter(function (x) { return x && /^\d{4}-\d{2}-\d{2}$/.test(x.d) && x.u; });

    /* Même titre et même miniature que la carte de l'entrée dans la liste du dessous (fiche site-journal-miniatures).
       La rubrique reste celle de l'entrée : l'en-tête des cartes (« Post · date ») ne dit pas la date du calendrier. */
    var cards = [].slice.call(document.querySelectorAll('.bjx--page .bj-card a[href]')).filter(function (a) { return !a.closest('.bjk-pick'); });
    items.forEach(function (x) {
      var a = null;
      for (var j = 0; j < cards.length; j++) { if (cards[j].getAttribute('href') === x.u) { a = cards[j]; break; } }
      if (!a) return;
      var t = a.querySelector('.bj-card__t'), im = a.querySelector('img');
      if (t && t.textContent.trim()) x.t = t.textContent.trim();
      if (PROVISOIRE.test(x.t)) x.t = nomDeCarte(a);
      var src = im && (im.getAttribute('src') || im.currentSrc);
      /* 25/10 (Journal tour 4) : [?&] devant width, sinon le premier « width= » trouvé est crop_width (photo découpée : vignette écrasée en 180 × 2 312) */
      if (src) x.i = src.indexOf('width=') > -1 ? src.replace(/([?&])width=\d+/, '$1width=180') : src;
    });
    items.forEach(function (x) { if (!x.t || PROVISOIRE.test(x.t)) x.t = x.k || T.repli; });

    var byDay = {};
    items.forEach(function (x) { (byDay[x.d] = byDay[x.d] || []).push(x); });

    var now = new Date();
    var nowKey = now.getFullYear() * 12 + now.getMonth();
    var keys = items.map(function (x) { return keyOf(x.d); });
    var minKey = keys.length ? Math.min.apply(null, keys) : nowKey;
    var lastKey = keys.length ? Math.max.apply(null, keys) : nowKey;
    var maxKey = Math.max(nowKey, lastKey);
    var cur = lastKey;
    var todayStr = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());

    var grid = root.querySelector('[data-bjk-grid]');
    var list = root.querySelector('[data-bjk-list]');
    var label = root.querySelector('[data-bjk-month]');
    var count = root.querySelector('[data-bjk-count]');
    var prev = root.querySelector('[data-bjk-prev]');
    var next = root.querySelector('[data-bjk-next]');

    function draw(dir) {
      var y = Math.floor(cur / 12), m = cur % 12;
      var first = (new Date(y, m, 1).getDay() + 6) % 7;
      var days = new Date(y, m + 1, 0).getDate();
      var html = '', rows = '', n = 0;
      for (var c = 0; c < 42; c++) {
        if (c % 7 === 0) html += '<div class="bjk__row" role="row">';
        var day = c - first + 1;
        if (day < 1 || day > days) {
          /* Les jours des mois voisins, en gris : la sixième semaine n'est jamais une rangée vide */
          var od = day < 1 ? new Date(y, m, 0).getDate() + day : day - days;
          html += '<div class="bjk__day is-out" role="gridcell"><span class="bjk__n">' + od + '</span></div>';
        } else {
          var ds = y + '-' + pad(m + 1) + '-' + pad(day);
          var e = byDay[ds];
          var cls = 'bjk__day' + (ds === todayStr ? ' is-today' : '');
          if (e) {
            n += e.length;
            var a = e[0];
            var img = a.i ? '<img src="' + esc(a.i) + '" alt="" loading="lazy" decoding="async">' : '<span class="bjk__ph">' + esc(a.k || T.repli) + '</span>';
            html += '<div class="' + cls + ' has" role="gridcell" data-d="' + ds + '"><a class="bjk__a" href="' + esc(a.u) + '" aria-label="' + fill(esc(T.jourAria), { d: day, m: esc(T.mois[m]), t: esc(a.t) }) + '">' +
              '<span class="bjk__th">' + img + '</span>' +
              '<span class="bjk__n">' + day + '</span>' +
              (e.length > 1 ? '<span class="bjk__more">+' + (e.length - 1) + '</span>' : '') +
              '<span class="bjk__cap">' + (a.k ? '<em>' + esc(a.k) + '</em>' : '') + esc(a.t) + '</span></a></div>';
            e.forEach(function (x) {
              rows = '<li><a href="' + esc(x.u) + '" data-d="' + ds + '"><span class="bjk__ld">' + fill(esc(T.dateLigne), { d: day, m: esc(T.moisCourt[m]) }) + '</span><span class="bjk__lt">' + esc(x.t) + '</span></a></li>' + rows;
            });
          } else {
            html += '<div class="' + cls + '" role="gridcell"><span class="bjk__n">' + day + '</span></div>';
          }
        }
        if (c % 7 === 6) html += '</div>';
      }
      grid.innerHTML = html;
      grid.classList.remove('is-in-l', 'is-in-r');
      if (dir) { void grid.offsetWidth; grid.classList.add(dir > 0 ? 'is-in-r' : 'is-in-l'); }
      list.innerHTML = rows || '<li class="bjk__none">' + esc(T.aucune) + '</li>';
      label.textContent = fill(T.titreMois, { m: T.mois[m].charAt(0).toUpperCase() + T.mois[m].slice(1), a: y });
      count.textContent = n ? fill(n > 1 ? T.comptePlus : T.compteUn, { n: n }) : T.compteZero;
      var f = document.activeElement;
      prev.disabled = cur <= minKey;
      next.disabled = cur >= maxKey;
      /* Au premier ou au dernier mois, le bouton pressé se désactive : le focus passe à l'autre au lieu de tomber sur la page */
      if (f === prev && prev.disabled && !next.disabled) next.focus({ preventScroll: true });
      else if (f === next && next.disabled && !prev.disabled) prev.focus({ preventScroll: true });
    }
    function go(d) {
      var k = cur + d;
      if (k < minKey || k > maxKey) return;
      cur = k; draw(d);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    root.addEventListener('keydown', function (ev) {
      if (ev.target.closest && ev.target.closest('input, textarea')) return;
      if (ev.key === 'ArrowLeft' && ev.target.closest('.bjk__nav')) { go(-1); }
      if (ev.key === 'ArrowRight' && ev.target.closest('.bjk__nav')) { go(1); }
    });
    /* La liste du mois montre son jour dans le calendrier */
    function mark(ev, on) {
      var l = ev.target.closest && ev.target.closest('a[data-d]');
      if (!l) return;
      var cell = grid.querySelector('.bjk__day[data-d="' + l.getAttribute('data-d') + '"]');
      if (cell) cell.classList.toggle('is-hl', on);
    }
    list.addEventListener('mouseover', function (ev) { mark(ev, true); });
    list.addEventListener('mouseout', function (ev) { mark(ev, false); });
    list.addEventListener('focusin', function (ev) { mark(ev, true); });
    list.addEventListener('focusout', function (ev) { mark(ev, false); });
    var x0 = null, y0 = null;
    grid.addEventListener('touchstart', function (ev) { var t = ev.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    grid.addEventListener('touchend', function (ev) {
      if (x0 === null) return;
      var t = ev.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? 1 : -1);
    }, { passive: true });
    draw(0);
    root.classList.add('is-ready');
  }

  /* Une rangée qui défile : les flèches avancent d'autant de cartes qu'on en voit ; la ligne dit où l'on en est. */
  function row(w) {
    var sc = w.querySelector('[data-bjp-scroll]');
    if (!sc) return;
    var pv = w.querySelector('[data-bjp-prev]'), nx = w.querySelector('[data-bjp-next]');
    function upd() {
      var max = sc.scrollWidth - sc.clientWidth, can = max > 2;
      w.classList.toggle('is-scroll', can);
      w.style.setProperty('--bjp-w', can ? (sc.clientWidth / sc.scrollWidth).toFixed(4) : '1');
      w.style.setProperty('--bjp-p', can ? Math.min(1, Math.max(0, sc.scrollLeft / max)).toFixed(4) : '0');
      if (pv) pv.disabled = !can || sc.scrollLeft <= 2;
      if (nx) nx.disabled = !can || sc.scrollLeft >= max - 2;
    }
    function step(d) {
      var li = sc.querySelector('.bj-card'), gap = parseFloat(getComputedStyle(sc).columnGap) || 0;
      var one = li ? li.getBoundingClientRect().width + gap : sc.clientWidth;
      var n = Math.max(1, Math.floor((sc.clientWidth + gap + 2) / one));
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      sc.scrollBy({ left: d * n * one, behavior: calm ? 'auto' : 'smooth' });
    }
    if (pv) pv.addEventListener('click', function () { step(-1); });
    if (nx) nx.addEventListener('click', function () { step(1); });
    sc.addEventListener('scroll', upd, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(upd).observe(sc); else window.addEventListener('resize', upd);
    window.addEventListener('load', upd);
    upd();
  }

  function boot() {
    document.querySelectorAll('[data-bjk]').forEach(init);
    document.querySelectorAll('[data-bjp]').forEach(row);
    document.querySelectorAll('.bjx--page .bj-card__t, .bjx--page .bjm__q').forEach(function (t) {
      if (PROVISOIRE.test(t.textContent)) t.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
